<template>
  <View.Container
    :breadcrumbs="props.breadcrumbs"
    :pending="props.pending"
    :icon="props.icon"
  >
    <template #actions>
      <slot name="actions" />
    </template>
    <template #callouts>
      <slot name="callouts" />
    </template>
    <template v-if="$slots.empty && !pending" #empty>
      <slot name="empty" />
    </template>
    <template #body>
      <div class="px-4 flex flex-col flex-1">
        <slot name="body" />
      </div>

      <!-- Padding to avoid <ChangeWidget> obstructing page content -->
      <div v-if="props.save" class="pb-action-gutter"></div>
      <ChangeWidget
        :saving="props.saving"
        :reset-changes="props.resetChanges"
        :has-unsaved-changes="props.hasUnsavedChanges"
        :save="props.save"
        :invalidations="props.invalidations"
      />
    </template>
  </View.Container>
  <RouterView />
</template>

<script lang="ts" setup>
import View, { Props as ViewProps } from "@/design_system/View";

import ChangeWidget, { Props as ChangeWidgetProps } from "./ChangeWidget.vue";

const props = defineProps<ViewProps & ChangeWidgetProps>();
</script>
